export default {
  refreshYourResults: 'Aggiorna i risultati',
  weNeedTo:
    'Per visualizzare i prezzi e la disponibilità più recenti, ti preghiamo di',
  refreshResults: 'aggiornare i risultati.',
  okRefresh: 'Ok, aggiorna',
}
